export const KIND_OF_INSURANCE = ["ICCA", "ICCB", "ICCC", "CONTINGENCY"];
export const CURRENCY = ["EUR", "USD", "GBP", "JPY", "CHF", "CNY"];
export const TERN = ["YES", "NO"];
export const PACKING_LIST = ["PIECES", "CONTAINERS"];
export const PACKING_LIST_RESTRICTED = ["PIECES"];
export const STORAGE = ["OPEN", "COVERED"];
export const DOCUMENTS = [
  { id: "H2", label: "H2" },
  { id: "H1", label: "H1" },
  { id: "MEMORANDUM", label: "Memorandum" },
  { id: "D1", label: "D1" },
  { id: "H1_CUSTOM_45", label: "H1 ( Customs procedure 45 )" },
  { id: "H4", label: "H4" },
  { id: "A22", label: "A22" },
];
export const REASON_OF_MOVEMENT = [
  { id: "INTERNAL_SERVICE", label: "Internal Service" },
  { id: "CUSTOMER_REQUEST", label: "Service on customer request " },
];
export const STATUS = [
  { id: "PENDING", label: "Pending" },
  { id: "EXECUTED", label: "Executed" },
];
export const INCOME_STATEMENT_FEATURE =
  String(process.env.INCOME_STATEMENT_FEATURE).toLowerCase() !== "false";
